import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61ae32f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "example-test-modal-component" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-info" }, "Como tirar uma foto do autoteste", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-info" }, " Esteja em um ambiente bem iluminado e certifique-se que a lente da câmera está limpa. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-info" }, " Posicione o cassete dentro dos limites da câmera, a uma distância próxima o suficiente para ler o resultado com nitidez. Tire a foto sem tremer ou borrar. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-info" }, "Exemplo da foto correta", -1))
const _hoisted_6 = { class: "body-info d-flex justify-content-center" }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_modal, { ref: "base-modal" }, {
      content: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            class: "test-image",
            src: _ctx.exampleTestPath
          }, null, 8, _hoisted_7)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}